import { receiveUserGeolocation, requestUserGeolocation } from '../../redux/actions/AppActionFunctions/AppActions';
const { REACT_APP_DEBUG } = process.env;
const debug = REACT_APP_DEBUG && false;
/** @deprecated whilst this populates the main `AppReducer`, it doesn't seem to be used anywhere */
export function getUserGeolocation() {
    return async (dispatch) => {
        dispatch(requestUserGeolocation());
        const locationRes = await new Promise((resolve, reject) => {
            debug && console.log('getting position');
            navigator.geolocation.getCurrentPosition((position) => {
                resolve(position.coords);
            }, (err) => {
                console.error('error in getUserGeolocation', err);
                reject(err);
            });
        });
        dispatch(receiveUserGeolocation(locationRes));
    };
}
